import { Injectable } from '@angular/core';
import { UserDataService } from '../Auth/data-access/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class DataAccessService {
  // NOTE: Dependency inversion: use interfaces
  constructor(
    public userData: UserDataService
  ) {}
}
